import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Case } from '@/types/case';

export const useCaseDetails = (caseId?: string | null) => {
  const [caseDetails, setCaseDetails] = useState<Case | null>(null);
  const [suggestedPrompts, setSuggestedPrompts] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDetails = async () => {
      if (!caseId) {
        setCaseDetails(null);
        setSuggestedPrompts([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const { data, error: dbError } = await supabase.from('cases').select(`*`).eq('id', caseId).single();
        if (dbError) throw dbError;
        setCaseDetails(data as Case);

        const suggestions = [
          `Analise o processo ${data.title} e identifique os principais pontos.`, 
          `Sugira ações para o status atual do processo ${data.status}.`,
          `Elabore um resumo do processo ${data.title}.`
        ];
        setSuggestedPrompts(suggestions);

      } catch (err: any) {
        console.error("Erro ao buscar detalhes do processo:", err);
        setError(err.message || "Erro ao carregar detalhes do processo.");
        setCaseDetails(null);
        setSuggestedPrompts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [caseId]);

  return { caseDetails, suggestedPrompts, loading, error };
};